export default "__VITE_PUBLIC_ASSET__287249de__"